export default __webpack_public_path__ + "static/media/iceberg.b3fe82b5.jpg";